export default __webpack_public_path__ + "static/media/rfc-logo.d0d25ce0.svg";